module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_right copy.eca836e3.jpeg";